import DataElementCard from "@/components/DataElementCard/index";
import Toast2 from '@/components/Toast2';
import { DATA_ElEMENT_TYPE } from '@/constants/package-sharing/index.js';
import { ToastContext } from "@/context/toast/index";
import useModal from "@/hooks/use-modal/index";
import usePackages from '@/hooks/use-packages/index.js';
import { useParams } from '@/lib/router-dom/index';
import { downloadFile } from "@/pages/eclip/utils/download-file.js";
import apiPackage from "@/services/api/packages.js";
import { transformCSVtoJSON } from '@/utils/csvtojson';
import addFormats from "@/utils/custom-ajv-formats";
import generateFileTypeErrorMessage from "@/utils/generate-file-type-error-message.js";
import Ajv from "ajv";
import jschardet from 'jschardet';
import moment from "moment";
import PropTypes from 'prop-types';
import { useCallback, useContext, useEffect, useState } from "react";
import { useDropzone } from 'react-dropzone';
import DownloadAllDataModal from "../../download-all-data-modal.jsx";
import DownloadDataModal from "../../download-data-modal.jsx";
import ImportDataModal from "../../import-data-modal.jsx";
import PackageConfirmDeleteModal from "../../package-confirm-delete-modal.jsx";
import ReceivedDataElementCard2 from "../../received-data-element-card-2.jsx";
import VerifiedByModal from "../../verified-by-modal.jsx";
import fileExtensions from "@/constants/file-extensions";

const ajv = new Ajv({ allErrors: true });
addFormats(ajv);

const VeridaptDataElementCard = ({
	reload,
	isPackageCopy,
	dataElement,
	handleRecipientChange,
	handleOnBehalfOfChange,
	onFillEformBtnClick,
	handleDataStructureUpload,
	handleAttachmentsUpload,
	handleRemoveAttachment,
	currentPackage,
	currentFolder
}) => {
	const packageActivity = "data_element";
	const { eclipId } = useParams();
	const { addToastMessage } = useContext(ToastContext);
	const { addRemoveDataElements, clearImportData } = usePackages()

	const [packageAttachments, setPackageAttachments] = useState([])
	const [veridaptRecipient, setVeridaptRecipient] = useState([])

	const { visible: veridaptVerifiedByVisible, hide: hideVeridaptVerifiedBy, show: showVeridaptVerifiedBy } = useModal();
	const { visible: veridaptDownloadModalVisible, hide: hideVeridaptDownloadModal, show: showVeridaptDownloadModal } = useModal();
	const { visible: veridaptImportDataVisible, hide: hideVeridaptImportDataModal, show: showVeridaptImportDataModal } = useModal();
	const { visible: veridaptDownloadAllModalVisible, hide: hideVeridaptDownloadAllModal, show: showVeridaptDownloadAllModal } = useModal();
	const { visible: veridaptConfirmDeleteVisible, hide: hideVeridaptConfirmDelete, show: showVeridaptConfirmDelete } = useModal();
	const { visible: veridaptConfirmClearVisible, hide: hideVeridaptConfirmClear, show: showVeridaptConfirmClear } = useModal();

	useEffect(() => {
		if (dataElement.savedPayload?.[0]?.attachments) {
			const attachments = dataElement.savedPayload[0].attachments
			const uploadedAttachment = attachments.map(file => ({ ...file, path: file.filename }))
			setPackageAttachments(uploadedAttachment)

		} else {
			setPackageAttachments([])
		}
	}, [dataElement])

	function packageRecipientChange(option) {
		setVeridaptRecipient(option)
		if (option[0]?.id === dataElement?.selectedRecipient[0]?.id) {
			return
		}
		handleRecipientChange(option, dataElement.dataElementId, dataElement.parent_node_id, dataElement.type)
	}

	function packageOnBehalfChange(option) {
		if (dataElement?.initalRecipient[0]?.id === veridaptRecipient[0]?.id && option[0]?.id === dataElement?.onBehalfOrgId) {
			return
		}

		if (veridaptRecipient.length === 0 && option[0]?.id === dataElement?.onBehalfOrgId) {
			return
		}
		handleOnBehalfOfChange(option, dataElement.dataElementId, dataElement.parent_node_id, dataElement.type)
	}

	function handleSubmitImportData() {
		reload()
	}

	/*=================================================
		Error Modal
	/================================================*/
	const [veridaptError, setVeridaptError] = useState("")
	function handleVeridaptError() {
		setVeridaptError("")
	}
	/*========================================================
		Import data, clear import data and delete Data Element
	/========================================================*/

	async function handleConfirmDeleteDataElement() {
		hideVeridaptConfirmDelete();
		const submitDataElement = [{
			dataElementId: dataElement.dataElementId,
			type: dataElement.type,
			parent_node_id: dataElement.parent_node_id,
			parent_node_type: dataElement.parent_node_type
		}]

		await addRemoveDataElements(eclipId, "REMOVE", submitDataElement);
		reload();
	}

	async function handleClearImportData() {
		hideVeridaptConfirmClear();
		await clearImportData(eclipId, dataElement.dataElementId, dataElement.parent_node_type, dataElement.parent_node_id)
		reload();
	}

	const packageMenu =
		[
			((dataElement.isOnBehalfOf && dataElement.selectedOnBehalfOf?.length > 0 && dataElement.selectedOnBehalfOf[0]?.id) || !dataElement.isOnBehalfOf) ? {
				label: "Import Data",
				onClick: (e) => {
					e.stopPropagation();
					showVeridaptImportDataModal()
				},
			} : undefined,
			dataElement.savedPayloadSource === "IMPORTED"
				? {
					label: "Clear Import Data",
					labelColor: "#A72E12",
					onClick: (e) => {
						e.stopPropagation();
						showVeridaptConfirmClear()
					},
				}
				: undefined,
			dataElement.packageDataElementType !== DATA_ElEMENT_TYPE.receiver_send ? {
				label: "Delete Data Element",
				labelColor: "#A72E12",
				onClick: (e) => {
					e.stopPropagation();
					showVeridaptConfirmDelete()
				},
			} : undefined,
		]

	/*=================================================
		Update the data element is New
	/================================================*/
	async function veridaptUpdateIsNew() {

		if (!dataElement.isNew) {
			return
		}

		const [error] = await apiPackage.updateIsNew(eclipId, dataElement.dataElementId, {
			type: dataElement.packageDataElementType,
			parent_node_id: dataElement.parent_node_id,
			parent_node_type: dataElement.parent_node_type
		});

		if (error) {
			addToastMessage("Failed to update new data element", "error");
			return
		}
		reload()
	}

	/*=================================================
		check if data element container attachment
	/================================================*/

	function checkContainAttachments(dataElement) {
		if (dataElement?.elementSchema?.properties && dataElement.elementSchema.properties.attachments) {
			return true;
		}

		if (dataElement?.schema?.anyOf) {
			for (const subSchema of dataElement.elementSchema.anyOf) {
				if (subSchema.properties && subSchema.properties.attachments) {
					return true;
				}
			}
		}
		return false;
	}

	/*=================================================
		Dropzone
	/================================================*/
	const [files, setFiles] = useState([])
	const [attachmentFiles, setAttachmentFiles] = useState([])

	const onDropPayloadRejected = useCallback(_rejectedFiles => {
		return setVeridaptError(generateFileTypeErrorMessage(['.csv']));
	}, []);

	const onDropAttachementRejected = useCallback(_rejectedFiles => {
		setVeridaptError(fileExtensions.errorMessage);
	}, []);

	const onDropPayloadVeridapt = useCallback(acceptedFiles => {
		acceptedFiles.forEach(file => {
			const reader = new FileReader()
			reader.onload = () => {
				const result = reader.result
				const encoding = jschardet.detect(result).encoding
				if (encoding.toLowerCase() !== 'utf-8' && encoding.toLowerCase() !== 'ascii') {
					setFiles([])
					setVeridaptError("Error: Invalid file type, please convert to UTF-8 encoding.")
					return
				}
				try {
					setFiles([])
					setFiles(files => [...files, Object.assign(file, {
						preview: URL.createObjectURL(file)
					})]);
				} catch (error) {
					setFiles([]);
					setVeridaptError("Error: Invalid JSON file format. Please check the file content.");
				}
			}
			reader.readAsBinaryString(file)
		})
	}, [])

	const onDropAttachmentVeridapt = useCallback(acceptedFiles => {
		const newFiles = acceptedFiles.map(file => Object.assign(file, {
			preview: URL.createObjectURL(file)
		}))

		if (newFiles.length === 0) {
			setVeridaptError(fileExtensions.errorMessage)
			return
		}

		setAttachmentFiles(oldFiles => {
			const checkedOldFiles = oldFiles.filter(oldFile => !newFiles.find(newFile => newFile.name === oldFile.name))
			const sumAllFiles = checkedOldFiles.reduce((prev, next) => { return prev + next.size }, 0);

			if ((sumAllFiles + newFiles[0].size) > 250000000) {
				setVeridaptError("Total files upload is more tha 250mb")
				return checkedOldFiles
			}
			const allFiles = checkedOldFiles.concat(newFiles)

			return allFiles
		})

	}, [])
	const { getRootProps: getRootPropsPayload, getInputProps: getInputPropsPayload } = useDropzone({ onDrop: onDropPayloadVeridapt, onDropRejected: onDropPayloadRejected, multiple: false, accept: 'text/csv' })
	const { getRootProps: getRootPropsAttachment, getInputProps: getInputPropsAttachment } = useDropzone({ onDrop: onDropAttachmentVeridapt, onDropRejected: onDropAttachementRejected, multiple: false, accept: fileExtensions.type })


	useEffect(() => {
		if (files.length === 0) {
			return
		}
		callbackUploadStructureData(files, dataElement)
	}, [files])

	useEffect(() => {
		callbackUploadAttachment(attachmentFiles)
	}, [attachmentFiles])

	/*=================================================
		Handle file
	/================================================*/

	function handleRemoveDataStructure() {
		handleDataStructureUpload([], {}, dataElement.dataElementId, dataElement.parent_node_id, dataElement.type)
		setPackageAttachments([])
	}

	function handleRemoveSingleAttachment(item) {
		const newFile = packageAttachments.filter((attachment) => attachment.path !== item)
		setPackageAttachments(newFile)
		handleRemoveAttachment(item, dataElement.dataElementId, dataElement.parent_node_id, dataElement.type)
	}


	/*=================================================
		Handle structure data upload
	/================================================*/

	async function readCSV(file, schema) {
		const fileReader = new FileReader();
		const content = await new Promise((resolve, reject) => {
			fileReader.onload = e => resolve(e.target.result);
			fileReader.onerror = e => reject(e);
			fileReader.readAsText(file, "utf-8");
		});

		const { convertedJSON } = await transformCSVtoJSON(content, schema);
		return convertedJSON;
	}

	function validateData(json, schema) {
		const validate = ajv.compile(schema);

		if (!Array.isArray(json)) {
			return validate(json)
		}
		return json.every(item => validate(item));
	}

	async function callbackUploadStructureData(files, dataElement) {
		if (files?.length !== 1) {
			addToastMessage("Invalid file count", "error");
			return
		}

		const file = files[0];
		let json;

		if (file.type === "text/csv" || file.type === "application/vnd.ms-excel") {
			json = await readCSV(file, dataElement.elementSchema);
		} else {
			addToastMessage("Invalid file type", "error");
			return;
		}

		if (!validateData(json, dataElement.elementSchema)) {
			setVeridaptError(
				`Invalid data uploaded for ${dataElement.name}. Please upload the correct .CSV file.` ||
				"Unable to submit pull request"
			);
			return;
		}

		if (!Array.isArray(json)) {
			json = [json];
		}

		json.forEach(item => { delete item.attachments });

		handleDataStructureUpload(json, file, dataElement.dataElementId, dataElement.parent_node_id, dataElement.type)
		setPackageAttachments([])

	}

	/*=================================================
		Handle attachment upload
	/================================================*/

	function hasDuplicatePath(attachmentFiles, attachments) {
		return attachmentFiles.some((file) => attachments.some((attachmentFile) => attachmentFile.path === file.path));
	}

	function clearAttachment() {
		setAttachmentFiles([]);
	}

	function callbackUploadAttachment(attachmentFiles) {
		if (attachmentFiles.length > 0) {

			if (hasDuplicatePath(attachmentFiles, packageAttachments)) {
				clearAttachment();
				addToastMessage("Same filename uploaded", "error");
				return
			}

			const mergedFiles = [...attachmentFiles, ...packageAttachments];
			clearAttachment();
			setPackageAttachments(mergedFiles)
			handleAttachmentsUpload(attachmentFiles, dataElement.dataElementId, dataElement.parent_node_id, dataElement.type)
		}
	}
	function handleDownloadSingleAttachment(attachment) {
		downloadFile(packageAttachments, attachment)
	}
	return (
		<>
			{((dataElement.messageStoreIds && dataElement.messageStoreIds.length === 0) || (!dataElement.messageStoreIds && !dataElement.messageStoreId)) && (
				<DataElementCard
					//State
					isPackage={true}
					isPackageSent={dataElement.isPackageSent}
					isPackageCopy={isPackageCopy}
					userType={dataElement.userType}
					packageDropdownMenu={packageMenu}
					verificationStatus={dataElement.verificationStatus}
					isPackageDownloadable={dataElement.isDownloadable}

					status={dataElement.status}
					dataElement={dataElement}

					//display and select participant
					participantsList={dataElement.participantList}
					recipient={dataElement.selectedRecipient}
					handleRecipientChange={packageRecipientChange}

					//display and select onBehalf
					behalfPanel={dataElement.isOnBehalfOf}
					onBehalfOfList={dataElement.onBehalfList}
					onBehalfOf={dataElement.selectedOnBehalfOf}
					handleOnBehalfOfChange={packageOnBehalfChange}

					// display, upload and remove structured data
					payload={dataElement.savedPayload}
					action={dataElement.action}
					getRootPropsPayload={getRootPropsPayload}
					getInputPropsPayload={getInputPropsPayload}
					handleRemoveFile={handleRemoveDataStructure}

					//display, upload attachment and remove attachment
					containAttachments={checkContainAttachments(dataElement)}
					attachments={packageAttachments}
					combineAttachments={packageAttachments.map(file => file.path)}
					optionalAttachments={[]}
					requiredAttachments={[]}
					matchingAttachments={packageAttachments}
					nonMatchingAttachments={[]}

					getRootPropsAttachment={getRootPropsAttachment}
					getInputPropsAttachment={getInputPropsAttachment}

					handleRemoveSingleFile={handleRemoveSingleAttachment}
					handleDownloadSingleFile={handleDownloadSingleAttachment}

					//Function
					onFillEformBtnClick={() => onFillEformBtnClick(dataElement, dataElement.savedPayloadSource === "IMPORTED" ? true : false)}
				/>
			)}

			{((dataElement.messageStoreIds && dataElement.messageStoreIds.length > 0) || (!dataElement.messageStoreIds && dataElement.messageStoreId))  && (
				<ReceivedDataElementCard2
					isPackageDownloadable={dataElement.isDownloadable}
					dataElement={dataElement}
					behalfPanel={dataElement.isOnBehalfOf}
					currentFolder={currentFolder}

					//Function
					handleShowDownloadModal={showVeridaptDownloadModal}
					handleShowDownloadAllModal={showVeridaptDownloadAllModal}
					updateIsNew={veridaptUpdateIsNew}
					currentPackage={currentPackage}
				/>
			)}

			<VerifiedByModal
				visible={veridaptVerifiedByVisible}
				close={hideVeridaptVerifiedBy}
				date={moment(dataElement.modified).format("lll")}
				issuerName={dataElement.issuerDetail?.[0]?.name}
				elementName={dataElement.elementName}
				isVerified={dataElement?.verificationStatus && dataElement.verificationStatus === 'VERIFIED'}
			/>

			<DownloadDataModal
				visible={veridaptDownloadModalVisible}
				close={hideVeridaptDownloadModal}
				messageStoreId={[dataElement.messageStoreId]}
				dataElementId={dataElement.dataElementId}
				isPackage={true}
				packageName={currentPackage?.name}
			/>

			<DownloadAllDataModal
				visible={veridaptDownloadAllModalVisible}
				close={hideVeridaptDownloadAllModal}
				messageStoreId={dataElement.messageStoreId ? [dataElement.messageStoreId]: dataElement.messageStoreIds}
				dataElementId={dataElement.dataElementId}
				isPackage={true}
				downloadName={currentPackage?.name}
				packageActivity={packageActivity}
				isMultiPayload={dataElement.messageStoreIds}
			/>

			<ImportDataModal
				visible={veridaptImportDataVisible}
				close={hideVeridaptImportDataModal}
				submit={handleSubmitImportData}
				dataElement={dataElement}
				version={'v2'}
			/>

			<PackageConfirmDeleteModal
				visible={veridaptConfirmDeleteVisible}
				title="Delete Data Element"
				text={`Are you sure want to delete ${dataElement.elementName} Data Element?`}
				close={hideVeridaptConfirmDelete}
				submit={handleConfirmDeleteDataElement}
			/>

			<PackageConfirmDeleteModal
				visible={veridaptConfirmClearVisible}
				title="Clear Imported Data"
				text={`Are you sure want to clear imported data for ${dataElement.elementName} data element?`}
				close={hideVeridaptConfirmClear}
				submit={handleClearImportData}
			/>

			<Toast2 show={veridaptError} errorMessage={veridaptError} title={"Invalid File"} warningIcon={true} close={() => { handleVeridaptError() }} />

		</>
	)

};

VeridaptDataElementCard.propTypes = {
	currentPackage: PropTypes.any,
	currentFolder: PropTypes.any,
	dataElement: PropTypes.shape({
		messageStoreId: PropTypes.any,
		messageStoreIds: PropTypes.array,
		isTTFlow: PropTypes.bool,
		isNew: PropTypes.bool,
		isOnBehalfOf: PropTypes.bool,
		verificationStatus: PropTypes.string,
		created: PropTypes.any,
		savedPayload: PropTypes.shape({
			attachments: PropTypes.array
		}),
		elementName: PropTypes.string,
		isPackageSent: PropTypes.bool,
		userType: PropTypes.string,
		isDownloadable: PropTypes.bool,
		status: PropTypes.string,
		participantList: PropTypes.array,
		selectedRecipient: PropTypes.array,
		onBehalfList: PropTypes.array,
		selectedOnBehalfOf: PropTypes.array,
		action: PropTypes.any,
		savedPayloadSource: PropTypes.string,
	})
};

export default VeridaptDataElementCard
